import { Link, useNavigate, useNavigation } from 'react-router-dom';
import { styled } from 'styled-components';
import { isLogin } from '../../utils/auth';
import PromotionService from '../../service/promotion/Promotion';
import UserService from '../../service/User';
import { useState, useEffect } from 'react';
import { useDidMountEffect } from '../../func/Function';
import PageTop, { MainPageTop } from '../components/pageTop/PageTop';
import Menu from '../components/menu/Menu';
import Footer from '../components/footer/Footer';

interface UserInfo {
  plan_grade: string | undefined;
}

const Promotion = () => {
  const navigate = useNavigate();

  const [code, setCode] = useState('');
  const [promotionCode, setPromotionCode] = useState('');
  const [userdata, setuserData] = useState<UserInfo>();
  const [alertModal, setAlertModal] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const [allow, setAllow] = useState({
    check1: true,
    check2: true,
    description1: false,
    description2: false,
  });

  const handleCopyAddress = () => {
    navigator.clipboard
      .writeText(window.location.href)
      .then(() => {
        alert('URL이 복사되었습니다!');
      })
      .catch((err) => {
        console.error('URL 복사에 실패했습니다:', err);
        alert('URL 복사에 실패했습니다.');
      });
  };

  const handleAllow = (key: string) => {
    setAllow((prev) => ({
      ...prev,
      [key]: !prev[key as keyof typeof allow],
    }));
  };

  const applyPromotion = async () => {
    try {
      if (!allow.check1 || !allow.check2) {
        return;
      }
      const response = await PromotionService.promotion(code);
      if (response) {
        setAlertModal(true);
      }
    } catch (error: any) {
      alert(
        error.response.data.message ||
          '오류가 발생했습니다. 다시 시도해주세요.',
      );
      console.error('Error applying promotion:', error);
    }
  };

  const getUserInfo = async () => {
    try {
      const res = await UserService.userInfo();
      setuserData(res.data);
    } catch (error) {
      console.error('userInfo 함수에서 에러 발생:', error);
    }
  };

  const getCode = async () => {
    try {
      if (!isLogin()) {
        return;
      }
      const response = await PromotionService.code();
      setCode(response.data.promo_code || ''); // 기본값 설정
    } catch (error: any) {
      alert(
        error.response.data.message ||
          '오류가 발생했습니다. 다시 시도해주세요.',
      );
      console.error('Error applying promotion:', error);
    }
  };

  const applyPromotionByDefaultCode = async () => {
    try {
      if (!allow.check1 || !allow.check2) return;

      const response = await PromotionService.promotion(code);
      if (response) {
        await getUserInfo();
        setAlertModal(true);
      }
    } catch (error: any) {
      alert(
        error.response?.data?.message ||
          '오류가 발생했습니다. 다시 시도해주세요.',
      );
      console.error('Error applying promotion with default code:', error);
    }
  };

  useEffect(() => {
    getCode();
    if (isLogin()) {
      getUserInfo();
    }
  }, []);
  return (
    <Component>
      <MainPageTop setOpenMenu={setOpenMenu} menu={true} />
      <Confirm_Button2
        href={!isLogin() ? '/login' : '#code'}
        allow
        disabled={userdata?.plan_grade === 'T'}
      >
        {!isLogin()
          ? '회원가입하고 이벤트 코드 확인하기 >'
          : userdata?.plan_grade === 'T'
            ? '이벤트 참여 완료'
            : '이벤트 참여하기'}
      </Confirm_Button2>
      <Container>
        <TopBar>
          <TopBar_Inner>
            <img
              src="/assets/images/promotion/Logo1.svg"
              alt=""
              style={{ width: '45px', height: '24px' }}
              onClick={() => navigate('/')}
            />
            <img
              src="/assets/images/promotion/Share.svg"
              alt=""
              style={{ marginRight: '-8px' }}
              onClick={handleCopyAddress}
            />
          </TopBar_Inner>
        </TopBar>

        <Title_Banner>
          <Title_Badge_Wrap>
            <Title_Badge>
              <Title_Badge_Text>오픈기념 이벤트</Title_Badge_Text>
            </Title_Badge>
          </Title_Badge_Wrap>
          <Main_Title_Wrap>
            <Main_Title>
              <h1>땅집고옥션</h1>
              <h1>신규회원 누구나</h1>
              <h1>멤버십 0원</h1>
            </Main_Title>
          </Main_Title_Wrap>
          <Main_Date_Wrap>
            <Main_Date>25.06.09(월) 까지</Main_Date>
          </Main_Date_Wrap>
          <Main_Wrap>
            <img
              src="/assets/images/promotion/Main1.png"
              alt=""
              style={{ marginTop: '-152px', width: '100%' }}
            />
            <Main_Description_Wrap>
              <Main_Description>
                이벤트 기간 동안 땅집고옥션 모든 서비스 무료
              </Main_Description>
            </Main_Description_Wrap>
          </Main_Wrap>
        </Title_Banner>

        <Content>
          <Content_Title>
            <h2>
              땅집고옥션 가입만 하면 <br />
              이벤트 기간 동안
              <span> 모든 서비스 무료</span>
            </h2>
          </Content_Title>
          <Content_Wrap>
            <li>
              <img
                src="/assets/images/promotion/Content1_2.png"
                alt=""
                style={{ position: 'absolute', right: 30.4, bottom: 0 }}
              />
              <img
                src="/assets/images/promotion/Content1_1.png"
                alt=""
                style={{ position: 'absolute', bottom: 55, right: 6.25 }}
              />
              <Content_Text>
                <Content_Sub_title>
                  <h3>
                    다양한 경공매 물건 검색 기능
                    <span style={{ fontFamily: 'Spoqa Han Sans Neo' }}>,</span>
                    <br />
                    <UnderLine>지도 검색</UnderLine> 가능
                  </h3>
                </Content_Sub_title>
                <Content_Description>
                  <span>땅집고옥션에서 간편하게 경공매를 분석해보세요</span>
                  <span>지도로 검색해 직관적인 비교, 분석이 가능합니다.</span>
                </Content_Description>
              </Content_Text>
            </li>
          </Content_Wrap>
          <Content_Wrap>
            <li>
              <img
                src="/assets/images/promotion/Content2_3.png"
                alt=""
                style={{
                  position: 'absolute',
                  right: 30,
                  bottom: 0,
                  width: '260px',
                }}
              />
              <img
                src="/assets/images/promotion/Content2_2.png"
                alt=""
                style={{
                  position: 'absolute',
                  right: 19,
                  bottom: 51,
                  width: '160.5px',
                }}
              />
              <img
                src="/assets/images/promotion/Content2_1.png"
                alt=""
                style={{ position: 'absolute', right: 196.59, bottom: 99 }}
              />
              <Content_Text>
                <Content_Sub_title>
                  <h3>
                    내 <UnderLine>알고리즘 분석</UnderLine>
                    <span style={{ fontFamily: 'Spoqa Han Sans Neo' }}>,</span>
                  </h3>
                  <h3>추천 기능</h3>
                </Content_Sub_title>
                <Content_Description>
                  <span>
                    나만의 경매 성공공식,
                    <br />
                    AI 알고리즘을 만들어보세요.
                    <br />
                    빅데이터 기반으로 경공매
                    <br />
                    투자 의사 결정을 지원합니다.
                  </span>
                </Content_Description>
              </Content_Text>
            </li>
          </Content_Wrap>
          <Content_Wrap>
            <li>
              <img
                src="/assets/images/promotion/Content3_4.png"
                alt=""
                style={{
                  position: 'absolute',
                  right: 30.15,
                  bottom: 0,
                }}
              />
              <img
                src="/assets/images/promotion/Content3_1.png"
                alt=""
                style={{
                  position: 'absolute',
                  right: 168.9,
                  bottom: 111,
                  width: '131.1px',
                }}
              />
              <img
                src="/assets/images/promotion/Content3_2.png"
                alt=""
                style={{
                  position: 'absolute',
                  right: 124.9,
                  bottom: 18,
                  width: '131.1px',
                }}
              />
              <img
                src="/assets/images/promotion/Content3_3.png"
                alt=""
                style={{
                  position: 'absolute',
                  right: 33,
                  bottom: 65,
                  width: '131.1px',
                }}
              />

              <Content_Text>
                <Content_Sub_title>
                  <h3>
                    돈되는 테마주
                    <span style={{ fontFamily: 'Spoqa Han Sans Neo' }}>,</span>
                  </h3>
                  <h3>
                    <UnderLine>퀀트 투자</UnderLine>
                  </h3>
                </Content_Sub_title>
                <Content_Description>
                  <span>AI경공매 퀀트 분석을 통해</span>
                  <span>12개의 퀀트 전략을 제공합니다.</span>
                  <span>시세보다 저평가된 물건부터</span>
                  <span>시세차익 물건까지 추천해드립니다.</span>
                </Content_Description>
              </Content_Text>
            </li>
          </Content_Wrap>
          <Content_Wrap>
            <li>
              <img
                src="/assets/images/promotion/Content4_2.png"
                alt=""
                style={{
                  position: 'absolute',
                  right: 30,
                  bottom: 0,
                  width: '260px',
                }}
              />
              <img
                src="/assets/images/promotion/Content4_1.png"
                alt=""
                style={{
                  position: 'absolute',
                  right: 20.21,
                  bottom: 92,
                  width: '108.79px',
                }}
              />

              <Content_Text>
                <Content_Sub_title>
                  <h3>약 40억건 데이터 학습 기반,</h3>
                  <h3>
                    <UnderLine>AI 분석 시스템</UnderLine>
                  </h3>
                </Content_Sub_title>
                <Content_Description>
                  <span>더이상 직감과 경험에 의존하지 마세요.</span>
                  <span>
                    땅집고옥션은 데이터로
                    <br />
                    투자 근거를 찾아드립니다!
                  </span>
                </Content_Description>
              </Content_Text>
            </li>
          </Content_Wrap>
        </Content>
        <Content2>
          <Content_Title>
            <h2>
              런칭 기념 이벤트 기간에만 <span>0원</span>
            </h2>
            <h2>신규 회원가입 혜택</h2>
          </Content_Title>
          <div style={{ position: 'relative' }}>
            <Shadow />
            <MemberShip_Wrap style={{ position: 'relative' }}>
              <MemberShip_Title>
                <MemberShip_Badge>
                  <span>Standard</span>
                </MemberShip_Badge>
                <MemberShip_Title_Text>전국 멤버십 기준</MemberShip_Title_Text>
              </MemberShip_Title>
              <MemberShip_Price_Row>
                <MemberShip_Price>상품금액</MemberShip_Price>
                <MemberShip_Price style={{ textDecoration: 'line-through' }}>
                  140<span style={{ fontFamily: 'Spoqa Han Sans Neo' }}>,</span>
                  000원
                </MemberShip_Price>
              </MemberShip_Price_Row>
              <div
                style={{
                  width: 'calc( 100% - 70px)',
                  height: '2px',
                  background: '#E1E2E4',
                }}
              />
              <MemberShip_Special>이벤트 기간에만! 0원</MemberShip_Special>
            </MemberShip_Wrap>
          </div>
        </Content2>
        <Confirm id="code">
          <Confirm_Title>
            <Confirm_Title1>땅집고옥션 6월9일 까지만!</Confirm_Title1>
            <Content_Title>
              <h2 style={{ color: '#000000' }}>
                <span style={{ color: '#0077FF' }}>0원</span>에 땅집고옥션
                누리는 방법
              </h2>
            </Content_Title>
          </Confirm_Title>
          <Data_Container>
            <Data_Wrap>
              <Data_Row>
                <Data_Title>이벤트 기간</Data_Title>
                <Data_Description>~6월9일 까지</Data_Description>
              </Data_Row>
              <Data_Row>
                <Data_Title>이벤트 대상</Data_Title>
                <Data_Description>신규 회원가입자 누구나!</Data_Description>
              </Data_Row>
              <Data_Row>
                <Data_Title>이벤트 혜택</Data_Title>
                <Data_Description>
                  월 14만원 상당의 혜택
                  <br />
                  <span>무료이용</span>
                </Data_Description>
              </Data_Row>
            </Data_Wrap>
          </Data_Container>
          {/* {isLogin() && (
            <Code_Form>
              <Code_Input_Form>
                <Code_Input_Title>이벤트 코드 입력</Code_Input_Title>
                <Code_Input_Field>
                  <Code_Input
                    value={promotionCode}
                    onChange={(e) => setPromotionCode(e.target.value)}
                    placeholder="이벤트 코드를 입력해주세요"
                  />
                </Code_Input_Field>
              </Code_Input_Form>
              <Code_Allow>
                <Event_Allow_Description>
                  이벤트 참여를 위해 개인정보 수집 및 이용
                  동의와 제3자 정보제공동의가 필요해요.
                </Event_Allow_Description>
                <Allow_Check_Row>
                  <Allow_Check>
                    <img
                      src={
                        !allow.check1
                          ? '/assets/images/check/signUpcheckOff.svg'
                          : '/assets/images/check/signUpcheckOn.svg'
                      }
                      style={{ width: '22px', height: '22px' }}
                      alt=""
                      onClick={() => handleAllow('check1')}
                    />
                    <Allow_Check_Name
                      onClick={() => handleAllow('description1')}
                    >
                      개인정보 수집 및 이용동의
                    </Allow_Check_Name>
                  </Allow_Check>
                  <img
                    src="/assets/images/arrow/arrow-down-gray.svg"
                    style={{ width: '24px', height: '24px' }}
                    alt=""
                    onClick={() => handleAllow('description1')}
                  />
                </Allow_Check_Row>
                <Allow_Detail open={allow.description1}>
                  개인정보보호법 규정에 따라 땅집고옥션 런칭기념 5월 무료체험'
                  이 벤트에 신청하시는 분께 수집하는 개인정보의 항목, 개인
                  정보의 수집 및 이용 목적, 개인정보의 보유 및 이용기간을 안내
                  드리오니 자세히 읽은후 동의하여 주시길 바랍니다.
                </Allow_Detail>
                <div
                  style={{
                    background: '#E1E2E4',
                    width: '100%',
                    height: '1px',
                  }}
                />
                <Allow_Check_Row>
                  <Allow_Check>
                    <img
                      src={
                        !allow.check2
                          ? '/assets/images/check/signUpcheckOff.svg'
                          : '/assets/images/check/signUpcheckOn.svg'
                      }
                      style={{ width: '22px', height: '22px' }}
                      alt=""
                      onClick={() => handleAllow('check2')}
                    />
                    <Allow_Check_Name
                      onClick={() => handleAllow('description2')}
                    >
                      제 3자 정보제공동의
                    </Allow_Check_Name>
                  </Allow_Check>
                  <img
                    src="/assets/images/arrow/arrow-down-gray.svg"
                    style={{ width: '24px', height: '24px' }}
                    alt=""
                    onClick={() => handleAllow('description2')}
                  />
                </Allow_Check_Row>
                <Allow_Detail open={allow.description2}>
                  ・제공받는 자 : (주)엠딕
                  <br />
                  ・제공받는 자의 이용 목적 : 프로모션 진행
                  <br />
                  ・제공하는 항목 : ID, 이름, 연락처
                  <br />
                  ・제공받는 자의 보유 및 이용기간 : 이벤트 신청일 <br />
                  이후 3개월 보관
                  <br />
                  <br />
                  동의를 거부하실 수 있으나 이벤트 참여가 불가능합니다.
                </Allow_Detail>
              </Code_Allow>
            </Code_Form>
          )} */}
          <HowToContainer>
            <HowTo>참여 방법</HowTo>
            <HowImg src="/assets/images/promotion/How.svg" />
          </HowToContainer>
          <SubmitDiv>
            <Event_Code_Wrap isLogin={isLogin()}>
              {isLogin() && (
                <img
                  src="/assets/images/promotion/Code.svg"
                  alt=""
                  style={{
                    position: 'absolute',
                    bottom: '-5px',
                    width: '100%',
                    height: '100%',
                  }}
                />
              )}
              <Event_text>이벤트 코드</Event_text>
              {isLogin() ? (
                <Event_Code>{code}</Event_Code>
              ) : (
                <Event_Need_Id>로그인 후 확인 가능합니다</Event_Need_Id>
              )}
            </Event_Code_Wrap>
            <Code_Input_Form>
              <Code_Input_Title>이벤트 코드 입력</Code_Input_Title>
              <InputField>
                <Code_Input_Field>
                  <Code_Input
                    value={code}
                    readOnly
                    placeholder="이벤트 코드를 입력해주세요"
                  />
                </Code_Input_Field>
              </InputField>
              <Confirm_Button
                onClick={() => {
                  if (isLogin() && userdata?.plan_grade !== 'T') {
                    applyPromotion();
                  }
                }}
                allow={isLogin() && allow.check1 && allow.check2}
                disabled={userdata?.plan_grade === 'T'}
              >
                {!isLogin()
                  ? '이벤트 참여'
                  : userdata?.plan_grade === 'T'
                    ? '참여 완료'
                    : '이벤트 참여'}
              </Confirm_Button>
            </Code_Input_Form>
          </SubmitDiv>

          {!isLogin() && (
            <Confirm_Button
              onClick={() => {
                if (isLogin()) {
                  applyPromotion();
                } else {
                  navigate('/login');
                }
              }}
              allow={
                !isLogin() ||
                (allow.check1 && allow.check2 && promotionCode !== '')
              }
              style={{ width: '90%' }}
            >
              {'회원가입하고 이벤트 코드 확인하기 >'}
            </Confirm_Button>
          )}
        </Confirm>
        <Footer_Container>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: '24px',
            }}
          >
            <Footer_Title>꼭 알아두세요!</Footer_Title>
            <Footer_Description>
              ・ ‘0원’ 무료체험 기간 : ~6/9
              <br />
              ・ 본 이벤트는 땅집고옥션 신규 회원이라면 누구나 참여 가능합니다.
              <br />
              ・ 이벤트 기간 내에 확인하신 코드 입력하셔서 0원에 땅집고옥션의
              기능을 이용해보세요.
              <br />
              ・ 해당 이벤트는 1개의 ID 당 1번만 참여 가능합니다.
              <br />
              ・ 본 이벤트는 부정한 방법으로 참여 시 무효처리되며 본사 사정에
              의해 혜택이 변경될 수 있습니다.
              <br />
              ・ 0원 프로모션 코드 사용하신 후 땅집고옥션 메인페이지 혹은
              결제내역에서 참여상태와 유효기간을 확인하실 수 있습니다.
              <br />
            </Footer_Description>
            <Footer_Title style={{ fontSize: '14px' }}>
              0원 프로모션 코드 안내
            </Footer_Title>
            <Footer_Description>
              ・ 프로모션 코드는 중복 사용이 불가합니다.
              <br />
              ・ 코드 유효기간 및 무료체험기간 : ~6/9 (6월 9일 23시 59분 59초에
              종료됩니다.)
              <br />
              <div>
                ・ 0원 코드 적용 멤버십 : 스탠다드 멤버십 1개월 이용권(스탠다드
                멤버십{' '}
                <Link
                  to="/payment/plan"
                  style={{
                    color: 'inherit',
                    display: 'inline',
                    textDecoration: 'underline',
                  }}
                >
                  자세히 보러가기
                </Link>
                )
              </div>
              ・ 0원 프로모션 코드의 경우 이벤트 기간 내에만 사용 가능합니다.
              (기간 연장 불가)
              <br />
            </Footer_Description>
          </div>
        </Footer_Container>
        {/* <Footer_Container2>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: '24px',
            }}
          >
            <img src="/assets/images/promotion/Logo1.svg" alt="" />
            <div style={{ width: '260px' }}>
              <CopyRight>COPYRIGHTⓒ 땅집고옥션, ALL RIGHT RESERVED.</CopyRight>
            </div>
          </div>
        </Footer_Container2> */}
        <Footer />
        <div style={{ height: '36px', width: '1px' }}></div>
        <Modal open={alertModal}>
          <Modal_Container>
            <Alert_Box>
              <Alert_Title>이벤트 참여 완료</Alert_Title>
              <Alert_Description>
                땅집고옥션 서비스를 자유롭게 이용해보세요!
              </Alert_Description>
            </Alert_Box>
            <Home_Button
              onClick={() => {
                setAlertModal(false);
                navigate('/');
              }}
            >
              홈으로
            </Home_Button>
          </Modal_Container>
        </Modal>
      </Container>
      {openMenu && <Menu page="main" setOpenMenu={setOpenMenu} />}
    </Component>
  );
};

const Modal = styled.div<{ open: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: ${(props) => (props.open ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
`;

const Alert_Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const Alert_Title = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #222222;
`;

const Alert_Description = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #616161;
`;

const Home_Button = styled.button`
  width: 312px;
  height: 47px;
  border-radius: 8px;
  padding-top: 12px;
  padding-right: 28px;
  padding-bottom: 12px;
  padding-left: 28px;
  background: #008aff;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #ffffff;
  cursor: pointer;
  border: none;
`;

const Modal_Container = styled.div`
  width: 360px;
  height: 174px;
  border-radius: 16px;
  padding: 24px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Code_Input_Form = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Code_Input_Title = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: calc(16px * -0.02);
  color: #616161;
`;

const Code_Input_Field = styled.div`
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  padding-top: 20px;
  padding-right: 16px;
  padding-bottom: 20px;
  padding-left: 16px;
  border: 1px solid #e1e2e4;
  background: #f7f8fc;
`;

const Code_Input = styled.input`
  width: 100%;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 18px;
  line-height: 145%;
  letter-spacing: calc(14px * -0.02);
  text-align: center;
  color: #222222;
  border: none;
  background: none;
`;

const Event_text = styled.div`
  position: relative;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 20px;
  line-height: 145%;
  letter-spacing: calc(16px * -0.02);
  text-align: center;
  color: #616161;
`;

const Event_Code = styled.div`
  position: relative;
  font-family: Paperlogy;
  font-weight: 700;
  font-size: 38px;
  text-align: center;
  user-select: text;

  background: linear-gradient(
    90deg,
    rgba(0, 138, 255, 1),
    rgba(139, 1, 254, 1),
    rgba(255, 1, 238, 1)
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  background-clip: text;
  color: transparent;
`;

const Event_Need_Id = styled.div`
  font-family: Paperlogy;
  font-weight: 700;
  font-size: 24px;
  line-height: 145%;
  letter-spacing: calc(14px * -0.02);
  text-align: center;
  color: #6c7584;
`;

const Event_Code_Wrap = styled.div<{ isLogin: boolean }>`
  position: relative;
  background: linear-gradient(
    102deg,
    #f2f4f3 -0.46%,
    #dcdfde 15.69%,
    #f2f4f3 20.85%,
    #dcdfde 52.56%,
    #f2f4f3 74.44%,
    #dcdfde 80.84%,
    #f2f4f3 88.31%
  );
  width: 100%;
  height: 114px;
  border-radius: 16px;
  padding-top: 24px;
  padding-bottom: 24px;
  gap: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${(props) =>
    props.isLogin &&
    `
    &::after {
      content: '';
      position: absolute;
      inset: 0;
      padding: 3px;
      border-radius: 16px;
      background: linear-gradient(
        90deg,
        rgba(0, 138, 255, 1),
        rgba(139, 1, 254, 1),
        rgba(255, 1, 238, 1)
      );
      -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
      z-index: 1;
      pointer-events: none;
    }
  `}
`;

const Data_Container = styled.div`
  border-radius: 24px;
  gap: 16px;
  padding: 24px 20px;
  box-shadow: 0px 4px 15px 0px #094c8426;
  background: #ffffff;
  display: flex;
  flex-direction: column;
`;

const Data_Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Data_Description = styled.span`
  font-family: Paperlogy;
  font-weight: 700;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: calc(16px * -0.02);
  color: #222222;
  span {
    color: #008aff;
    font-family: Paperlogy;
  }
`;

const Data_Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 18px;
`;

const Data_Title = styled.div`
  width: 99px;
  height: 32px;
  border-radius: 9999px;
  padding-top: 6px;
  padding-bottom: 6px;
  gap: 10px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: calc(14px * -0.02);
  text-align: center;
  color: #ffffff;
  background: #008aff;
  align-self: flex-start;
`;

const MemberShip_Special = styled.span`
  font-family: Paperlogy;
  font-weight: 700;
  font-size: 20px;
  line-height: 145%;
  letter-spacing: calc(20px * -0.02);
  color: #229bff;
`;

const MemberShip_Price = styled.span`
  font-family: Paperlogy;
  font-weight: 700;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: calc(14px * -0.02);
  color: #616161;
`;

const MemberShip_Price_Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const MemberShip_Wrap = styled.div`
  border-top-left-radius: 32px;
  border-top-right-radius: 32px;
  background: linear-gradient(180deg, #f1f5ff 47.79%, #d3ddf8 100%);
  box-shadow: 0px 4px 4px 0px #00000040;
  padding: 32px 21px;
  gap: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MemberShip_Title_Text = styled.span`
  font-family: Paperlogy;
  font-weight: 700;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: calc(14px * -0.02);
  color: #222222;
`;

const MemberShip_Title = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

const MemberShip_Badge = styled.div`
  border-radius: 4px;
  padding-top: 2px;
  padding-right: 16px;
  padding-bottom: 2px;
  padding-left: 16px;
  background: linear-gradient(105.88deg, #00a2e7 0%, #94bf08 100%);
  border: 2px solid linear-gradient(94.45deg, #3cb5de 0%, #aad545 100%);
  span {
    font-family: Paperlogy;
    font-weight: 700;
    font-size: 14px;
    line-height: 145%;
    letter-spacing: 0%;
    text-align: center;
    color: #ffffff;
  }
`;

const UnderLine = styled.span`
  background-image: linear-gradient(to top, #74e3ef 40%, transparent 40%);
  background-repeat: no-repeat;
  background-size: 110% 1em;
  background-position: 0 100%;
  font-family: Paperlogy;
`;

const Footer_Description = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 12px;
  line-height: 145%;
  letter-spacing: calc(12px * -0.02);
  color: #b0b0b0;
  word-break: keep-all;
`;

const Footer_Title = styled.div`
  font-family: Paperlogy;
  font-weight: 700;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: calc(16px * -0.02);
  text-align: center;
  color: #ffffff;
`;

const Confirm_Button = styled.div<{ allow?: boolean; disabled?: boolean }>`
  border-radius: 16px;
  padding-top: 20px;
  padding-bottom: 20px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  font-size: 18px;
  line-height: 145%;
  letter-spacing: calc(18px * -0.02);
  text-align: center;
  cursor: ${(props) =>
    props.allow && !props.disabled ? 'pointer' : 'not-allowed'};
  color: ${(props) =>
    props.allow && !props.disabled ? '#ffffff' : '#37383C29'};
  background: ${(props) =>
    props.allow && !props.disabled ? '#008aff' : '#F7F7F8'};
  border-radius: 16px;
  width: 100%;
  height: 66px;
`;

const Confirm_Title = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-direction: column;
`;

const Confirm_Title1 = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: calc(14px * -0.02);
  text-align: center;
  color: #0077ff;
`;

const Confirm = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 72px 0;
  gap: 40px;
  background: #ecf3ff;
  flex-direction: column;
`;

const Footer_Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 20px;
  background: #1f1f1f;
`;

const Shadow = styled.span`
  width: calc(100% + 60px);
  height: 32px;
  border-radius: 9999px;
  position: absolute;
  bottom: 0;
  left: -30px;
  background: linear-gradient(180deg, #100581 0%, #100c3c 100%);
`;

const Content2 = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 72px 0;
  gap: 40px;
`;

const Content_Text = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Content_Sub_title = styled.div`
  h3 {
    margin: 0;
    font-family: Paperlogy;
    font-weight: 700;
    font-size: 24px;
    line-height: 145%;
    letter-spacing: calc(24px * -0.02);
    text-align: center;
    span {
      font-family: Paperlogy;
    }
  }
`;

const Content_Description = styled.div`
  span {
    font-family: Spoqa Han Sans Neo;
    font-weight: 500;
    font-size: 14px;
    line-height: 145%;
    letter-spacing: calc(14px * -0.02);
    color: #616161;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

const Content_Wrap = styled.ul`
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  flex-direction: column;
  gap: 10px;
  width: 100%;

  li {
    position: relative;
    overflow: hidden;
    padding: 23px;
    height: 362px;
    background: #ffffff;
    border-radius: 24px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    max-width: 335px;
  }
`;

const Content_Title = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  h2 {
    margin: 0;
    font-family: Paperlogy;
    font-weight: 700;
    font-size: 24px;
    line-height: 145%;
    letter-spacing: calc(24px * -0.02);
    text-align: center;
    color: #ffffff;
    span {
      font-family: Paperlogy;
      color: #68caff;
    }
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 72px 0 0;
`;

const Component = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Container = styled.div`
  background: #050037;
  user-select: none;
  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  box-shadow: 0 0 20px hsla(0, 0%, 51%, 0.15);
  overflow: hidden;
  position: relative;
`;

const TopBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const TopBar_Inner = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding: 16px 20px;
  align-items: center;

  img {
    height: auto;
    cursor: pointer;
  }
`;

const Title_Banner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  padding: 20px 0 0;
`;

const Title_Badge_Wrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Title_Badge = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 8px;
  padding-right: 32px;
  padding-bottom: 8px;
  padding-left: 32px;
  border-radius: 9999px;
  border: 2px solid #dd92ff;
`;

const Title_Badge_Text = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: calc(16px * -0.02);
  color: #dd92ff;
`;

const Main_Title_Wrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Main_Title = styled.div`
  background: linear-gradient(
    180deg,
    #ffffff 6.08%,
    #80adff 53.04%,
    #f88bff 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  padding-block: 20px 32px;

  h1 {
    margin: 0;
    font-family: Paperlogy;
    font-weight: 700;
    font-size: 34px;
    line-height: 120%;
    letter-spacing: 0%;
    text-align: center;
  }
`;

const Main_Date_Wrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 20px;
`;

const Main_Date = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: calc(16px * -0.02);
  color: #ffffff;
`;

const Main_Wrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const Main_Description_Wrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-block: 24px;
`;

const Main_Description = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: calc(14px * -0.02);
  color: #e5fcff;
`;

const Confirm_Button2 = styled.a<{ allow?: boolean; disabled?: boolean }>`
  text-decoration: none;
  padding-top: 20px;
  padding-bottom: 20px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  font-size: 20px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: ${({ allow, disabled }) =>
    disabled ? '#989BA2' : allow ? '#ffffff' : '#37383C29'};
  background: ${({ allow, disabled }) =>
    disabled ? '#F7F7F8' : allow ? '#008aff' : '#F7F7F8'};
  cursor: pointer;
  width: 100%;
  position: fixed;
  z-index: 5;
  bottom: 0;
`;

const HowToContainer = styled.div`
  width: 96%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
`;

const HowTo = styled.div`
  padding: 8px 32px;
  border: 2px solid #008aff;
  border-radius: 9999px;
  color: #008aff;
  font-size: 16px;
  font-weight: 500;
`;

const HowImg = styled.img`
  width: 100%;
  height: 100%;
`;

const SubmitDiv = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  align-items: center;
  padding: 24px;
  border: 5px solid #008aff;
  border-radius: 24px;
  background: #ffffff;
`;

const InputField = styled.div`
  width: 100%;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export default Promotion;
